import getColor from "@insite/mobius/utilities/getColor";
import { inputStyles } from "@store/theme/common/mixins";
import { formFieldBorderTypes, formFieldSizeVariants } from "@store/theme/common/props/form";
import { TYPOGRAPHY } from "@store/theme/design";
import { css } from "styled-components";

export const adyenStyles = css`

    ${(props) => {
        return css`
            color: ${getColor("primary.light")};
            .adyen-frame {

                .adyen-checkout__payment-method {
                    /* Payment method container */
                }
                .adyen-checkout__payment-method--selected {
                    /* Payment method that has been selected */
                }
                .adyen-checkout__payment-method__name {
                    /* Payment method name in the payment method header */
                }
                .adyen-checkout__spinner__wrapper {
                    /* Spinning icon */
                }
                .adyen-checkout__field {
                    /* Form field container */
                }

            /*******************************************
            *** HEADER *********************************
            *******************************************/
                
                .adyen-checkout__payment-method__header {
                    /* Payment method icon and name */
                    font-family: ${TYPOGRAPHY.fontFamily.base};
                    .adyen-checkout__payment-method__header__title {
                        font-family: ${TYPOGRAPHY.fontFamily.base};
                    }
                }

            /*******************************************
            *** BUTTON *********************************
            *******************************************/
            
                .adyen-checkout__button {
                    /* Buttons */
                    font-family: ${TYPOGRAPHY.fontFamily.base};

                    &.adyen-checkout__button--link {
                        color: ${getColor("primary")};
                        font-size: ${TYPOGRAPHY.size.smaller};
                        font-weight: ${TYPOGRAPHY.weight.bold};
                    }
                }
                .adyen-checkout__button--pay {
                    /* Pay button */
                }

            /*******************************************
            *** LABEL **********************************
            *******************************************/

                .adyen-checkout__label {
                    /* Form label container */
                    font-family: ${TYPOGRAPHY.fontFamily.base};
                }
                .adyen-checkout__label--focused {
                    .adyen-checkout__label__text {
                        color: ${getColor("text.main")};
                    }
                }
                .adyen-checkout__label__text {
                    /* Text element inside the form label container */
                    color: ${getColor("text.main")};
                    font-size: ${TYPOGRAPHY.size.small};
                    font-weight: ${TYPOGRAPHY.weight.bold};

                    /* comes from FormField.tsx */
                    min-height: 22px;
                    margin-bottom: 0;

                    &.adyen-checkout__label__text--error {
                        color: ${getColor("text.main")};
                    }
                }


            /*******************************************
            *** RADIO **********************************
            *******************************************/

                .adyen-checkout__payment-method {
                    &:hover:not(.adyen-checkout__payment-method--selected) {
                        .adyen-checkout__payment-method__radio {
                            box-shadow: none;
                        }
                    }
                }
                .adyen-checkout__payment-method__radio {
                    /* Radio button in payment method header */
                    border: ${formFieldBorderTypes.inactive.width}px solid ${getColor("common.border")};
                }
                .adyen-checkout__payment-method__radio--selected {
                    /* Selected radio button in payment method header */
                    background-color: ${getColor("primary.main")};
                    border: ${formFieldBorderTypes.inactive.width}px solid ${getColor("common.outline")};
                    box-shadow: none;
                    
                    &:active,
                    &:focus {
                        border: ${formFieldBorderTypes.inactive.width}px solid ${getColor("common.outline")};
                        box-shadow: none;
                        &:hover {
                            border: ${formFieldBorderTypes.inactive.width}px solid ${getColor("common.outline")};
                            box-shadow: none;
                        }
                    }
                    &:hover {
                        box-shadow: none;
                    }
                }

                .adyen-checkout__radio_group__input {
                    /* Radio buttons */
                }

            /*******************************************
            *** INPUT *********************************
            *******************************************/

                .adyen-checkout__input {
                    /* Input fields */
                    ${inputStyles()}
                    border: ${formFieldBorderTypes.inactive.width}px solid ${getColor("common.border")};
                    border-radius: ${formFieldSizeVariants.default.borderRadius}px;
                    font-family: ${TYPOGRAPHY.fontFamily.base};
                    font-size: ${formFieldSizeVariants.default.fontSize}px;
                    height: ${formFieldSizeVariants.default.height}px;

                    &.adyen-checkout__input--focus,
                    &:active,
                    &:focus {
                        border: ${formFieldBorderTypes.inactive.width}px solid ${getColor("common.outline")};
                        box-shadow: none;
                        &:hover {
                            border: ${formFieldBorderTypes.inactive.width}px solid ${getColor("common.outline")};
                            box-shadow: none;
                        }
                    }
                    &:hover {
                        box-shadow: none;
                    }
                }
                .adyen-checkout__input--error, /* Error state for the input fields */
                .adyen-checkout__input--invalid {
                    border-color: ${getColor("danger.main")};

                    .adyen-checkout__icon {
                        color: ${getColor("danger.main")};
                    }
                }

            /*******************************************
            *** INPOT - SPECIFIC ***********************
            *******************************************/
                
                .adyen-checkout__card__cardNumber__input {
                    /* Input field for the card number */
                }
                .adyen-checkout__field--expiryDate {
                    /* Input field for the expiry date */
                }
                .adyen-checkout__field__cvc {
                    /* Input field for the CVC security code */
                }
                .adyen-checkout__card__holderName {
                    /* Input field for cardholder name */
                }

            /*******************************************
            *** ERROR **********************************
            *******************************************/
            
                .adyen-checkout__error-text {
                    /* Error message text */
                    font-size: ${TYPOGRAPHY.size.smallest};
                    font-weight: ${TYPOGRAPHY.weight.bold};
                    border-color: ${getColor("danger.main")};
                }

            /*******************************************
            *** CHECKBOX ******************************
            *******************************************/
                .adyen-checkout__checkbox__input {
                    /* Checkboxes */

                    &+.adyen-checkout__checkbox__label {
                        /* Checkbox labels */
                        font-family: ${TYPOGRAPHY.fontFamily.base};
                        font-size: ${TYPOGRAPHY.size.smallest};
            
                        &:before {
                            height: 12px;
                            width: 7px;
                        }
                        &:after {
                            border: ${formFieldBorderTypes.inactive.width}px solid ${getColor("common.border")};
                            height: 18px;
                            width: 18px;
                        }
                    }
                    &:checked {
                        &+.adyen-checkout__checkbox__label {
                            &:after {
                                background-color: ${getColor("primary.main")};
                            }
                        }
                    }
                    &:hover:not(:focus),
                    &:hover,
                    &:checked,
                    &:focus {
                        &+.adyen-checkout__checkbox__label:after {
                            box-shadow: none;
                        }
                        &:hover {
                            &+.adyen-checkout__checkbox__label:after {
                                box-shadow: none;
                            }
                        }
                    }
                    &:active, 
                    &:focus {
                        &+.adyen-checkout__checkbox__label:after {
                            border: ${formFieldBorderTypes.inactive.width}px solid ${getColor("common.outline")};
                        }
                        &:hover {
                            &+.adyen-checkout__checkbox__label:after {
                                border: ${formFieldBorderTypes.inactive.width}px solid ${getColor("common.outline")};
                            }
                        }
                    }
                }

            /*******************************************
            *** DROPDOWN *******************************
            *******************************************/

                .adyen-checkout__dropdown {
                    &+.adyen-checkout-input__inline-validation {
                        right: 36px;
                    }
                }
                .adyen-checkout__dropdown__button {
                    /* Dropdown button showing list of options */
                    ${inputStyles()}
                    border: ${formFieldBorderTypes.inactive.width}px solid ${getColor("common.border")};
                    border-radius: ${formFieldSizeVariants.default.borderRadius}px;
                    font-family: ${TYPOGRAPHY.fontFamily.base};
                    font-size: ${formFieldSizeVariants.default.fontSize}px;
                    height: ${formFieldSizeVariants.default.height}px;

                    &.adyen-checkout__dropdown__button--active,
                    &:active,
                    &:focus {
                        border: ${formFieldBorderTypes.inactive.width}px solid ${getColor("common.outline")};
                        box-shadow: none;
                        
                        &:hover {
                            border: ${formFieldBorderTypes.inactive.width}px solid ${getColor("common.outline")};
                            box-shadow: none;
                        }
                    }
                    &:hover {
                        box-shadow: none;
                    }
                    &:after {
                        content: url("data:image/svg+xml,%3Csvg focusable='false' xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E ");
                        background-image: none;
                        height: 22px;
                        position: absolute;
                        right: 10px;
                        width: 24px;
                    }
                }
                .adyen-checkout__dropdown__list {
                    /* Dropdown list */
                    font-family: ${TYPOGRAPHY.fontFamily.base};
                }
                .adyen-checkout__dropdown__element {
                    /* Elements in the dropdown list */
                }


            /*******************************************
            *** LINK ***********************************
            *******************************************/

                .adyen-checkout__link {
                    /* Links */
                    color: ${getColor("primary.main")};
                    font-family: ${TYPOGRAPHY.fontFamily.base};
                    font-size: ${TYPOGRAPHY.size.smaller};
                    font-weight: ${TYPOGRAPHY.weight.bold};
                }


            /*******************************************
            *** FIELDSET *******************************
            *******************************************/

                .adyen-checkout__fieldset {
                    .adyen-checkout__fieldset__title {
                        letter-spacing: 0.5px;
                    }
                }
            }
        `;
    }}
`;